import {Injectable} from '@angular/core';
import { API } from '../../constants/api.constants';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class CompanyService {

    private resourceUrl = API.host + 'companies';

    constructor(
        private http: Http,
        private router: Router,
    ) {}

    isCompanyExists(id: number): Observable<boolean>{
        // get SystemSetting lưu từ LocalStorage, nếu không có thì get từ DB 
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid request';
            }

            return res.json().data;
        })
    }

    getIdFromUrl(): number {
        var url = this.router.url === '/' ? '' : this.router.url;
        const urlAndQuery = url.split('?');
        const pathMap = urlAndQuery[0].split('/');
        // first element is an empty string, second element of the path segments is the tenant
        const tennantId = pathMap[1];
        
        if (isNaN(Number(tennantId))){
            return -1;
        }

        return Number(tennantId);
    }
}
